/* Exécute `task` sur `items` avec au plus `limit` appels simultanés — un
   Promise.all non borné sur un gros lot a provoqué des "Failed to fetch"
   réseau (NAI-218, PR #2131). Partagé entre les flux "Valider toutes les
   copies" et "Corriger toutes les copies". */
export async function runWithConcurrencyLimit<T>(
  items: T[],
  limit: number,
  task: (item: T) => Promise<void>,
): Promise<void> {
  let nextIndex = 0;
  const worker = async () => {
    while (nextIndex < items.length) {
      const item = items[nextIndex];
      nextIndex += 1;
      await task(item as T);
    }
  };
  await Promise.all(Array.from({ length: Math.min(limit, items.length) }, () => worker()));
}
